import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";

export default function TRAInput({
  className,
  error,
  id,
  "aria-describedby": ariaDescribedBy,
  ...rest
}) {
  const errorId = error && id ? `${id}-error` : undefined;
  const describedBy = [ariaDescribedBy, errorId].filter(Boolean).join(" ") || undefined;
  return (
    <input
      id={id}
      className={cn(styles.input, error && styles.inputError, className)}
      aria-invalid={error ? true : undefined}
      aria-describedby={describedBy}
      {...rest}
    />
  );
}

export function TRAFormField({
  label,
  hint,
  error,
  id,
  className,
  inputClassName,
  children,
  ...inputRest
}) {
  const inputId = id || inputRest.name;
  const hintId = hint && inputId ? `${inputId}-hint` : undefined;
  const errorId = error && inputId ? `${inputId}-error` : undefined;
  return (
    <div className={cn(styles.inputWrap, className)}>
      {label ? (
        <label className={styles.inputLabel} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      {children || (
        <TRAInput
          id={inputId}
          className={inputClassName}
          error={error}
          aria-describedby={[hintId, errorId].filter(Boolean).join(" ") || undefined}
          {...inputRest}
        />
      )}
      {hint && !error ? (
        <p className={styles.inputHint} id={hintId}>
          {hint}
        </p>
      ) : null}
      {error ? (
        <p className={styles.inputErrorText} id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
